import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Footer from "../common/Footer";
import SendcoinsOpen from "./SendcoinsOpen";
import EditUserModal from "../modals/EditUser";
import OrgLogo from "../../assets/Organization.png";
import IndLogo from "../../assets/Individual.png";
import AdmLogo from "../../assets/Admin.png";
import BuyDM from "../modals/BuyDM";
import "./profileview.css";

function ProfileView() {
  const [user, setUser] = useState({});
  const { userName } = useParams();
  const [profile, setProfile] = useState("");
  const [cuser, setCuser] = useState({});
  const userToken = localStorage.getItem("userToken");
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState({ businessName: "", _id: "" });
  const [showModal, setShowModal] = useState(false);
  const [showBuyModal, setShowBuyModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadUser = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_LOCAL_API}/viewuser/${userName}`
      );
      const data = res.data.data;
      setUser(data);
      const types = {
        individual: "Individual",
        ngo: "NGO",
        business: "Business",
        impactOrg: "Impact Organisation",
      };
      setProfile(types[data.profileType] || "");
    } catch {
      setError("Failed to load user profile");
    } finally {
      setLoading(false);
    }
  };

  const loadCurrentUser = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_LOCAL_API}/user`, {
        headers: { Authorization: `Bearer ${userToken}` },
      });
      setCuser(res.data.data);
    } catch (err) {
    }
  };

  useEffect(() => {
    loadUser();
    loadCurrentUser();
  }, []);

  if (loading)
    return (
      <div className="profile-container">
        <div className="profile-card loading">Loading...</div>
      </div>
    );

  if (error)
    return (
      <div className="profile-container">
        <div className="profile-card error">{error}</div>
      </div>
    );

  return (
    <>
      <div className="profile-container">
        <div className="profile-card">
          {/* Top section: avatar + name + type */}
          <div className="profile-header-row">
            <img
              src={
                user?.profilePic ||
                (user?.profileType === "admin"
                  ? AdmLogo
                  : user?.profileType === "individual"
                    ? IndLogo
                    : OrgLogo)
              }
              alt="profile"
              className="profile-avatar-side"
            />
            <div className="profile-name-type">
              <h2 className="profile-name">{user?.businessName || `${user?.firstName} ${user?.lastName}`}</h2>
              <p className="profile-type">{profile}</p>
              {user?._id === cuser?._id && (
                <button className="edit-btn" onClick={() => setShowEdit(true)}>
                  Edit Profile
                </button>
              )}
            </div>
          </div>

          {/* About section */}
          <div className="profile-about">
            <h3>About</h3>
            {user?.about ? (
              <div dangerouslySetInnerHTML={{ __html: user?.about }} />
            ) : (
              <p>
                {user?.profileType === "impactOrg" ||
                  user?.profileType === "business" ||
                  user?.profileType === "ngo"
                  ? `${user?.businessName || "This organization"} is a ${user?.country || "global"
                  } ${profile.toLowerCase()}.`
                  : `${user?.firstName} ${user?.lastName} is an individual user.`}
              </p>
            )}
          </div>

          {/* Info section */}
          <div className="profile-info">
            <div className="info-grid">
              {(user?.profileType === "business" ||
                user?.profileType === "ngo" ||
                user?.profileType === "impactOrg") && (
                  <div className="info-item">
                    <strong>Contact Name:</strong>{" "}
                    <span>{`${user?.firstName} ${user?.lastName}`}</span>
                  </div>
                )}
              <div className="info-item">
                <strong>Country:</strong> <span>{user?.country || "N/A"}</span>
              </div>
              {user?.website && (
                <div className="info-item">
                  <strong>Website:</strong>{" "}
                  <a
                    href={user?.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {user?.website}
                  </a>
                </div>
              )}
            </div>
          </div>

          {/* Support Section */}
          <div className="profile-support">
            <h3>
              Support{" "}
              <strong>
                {user?.businessName ||
                  `${user?.firstName} ${user?.lastName}`}
              </strong>{" "}
              Now
            </h3>
            <div className="profile-actions">
              <button
                className="donate-cash"
                onClick={() => setShowBuyModal(true)}
              >
                Donate Cash
              </button>
              <button
                className="donate-dm"
                onClick={() => setShowModal(true)}
              >
                💸 Donate DM
              </button>
            </div>
          </div>
        </div>

        {/* Modals */}
        <EditUserModal
          userId={user?._id}
          userToken={userToken}
          onClose={() => setShowEdit(false)}
          showEdit={showEdit}
          isAdmin={false}
        />
        <BuyDM isModalOpen={showBuyModal} setIsModalOpen={setShowBuyModal} selectedUser={user} />
        <SendcoinsOpen
          showModal={showModal}
          closeModal={() => setShowModal(false)}
          user={selected}
        />
      </div>
      <Footer />
    </>
  );
}

export default ProfileView;
